"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRHead = void 0;
const react_1 = __importStar(require("react"));
const ssr_render_context_1 = __importDefault(require("../common/context/ssr-render-context"));
const vars_1 = require("../common/constants/vars");
const serialize_javascript_1 = __importDefault(require("serialize-javascript"));
exports.SSRHead = react_1.default.memo(() => {
    var _a;
    const context = (0, react_1.useContext)(ssr_render_context_1.default);
    if (context === null) {
        throw new Error('You have to place SSRHead inside SSRRenderContext!!!');
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        context.head, (_a = context.styles) === null || _a === void 0 ? void 0 :
        _a.map((href) => react_1.default.createElement("link", { key: href, href: href, rel: "stylesheet", type: "text/css" })),
        react_1.default.createElement("script", { dangerouslySetInnerHTML: { __html: `window.${vars_1.APP_VAR} = (${(0, serialize_javascript_1.default)(context.state, { isJSON: true })})` } })));
});
exports.SSRHead.displayName = 'SSRHead';
//# sourceMappingURL=ssr-head.js.map